import React from 'react';

import {isElectron} from '../../../../libs/shared/core/src/helpers/environment/platformHelpers';
import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {DataEventActionsEnum} from '../../../../libs/shared/core/src/models/tracking/dataEventActions';
import {DataEventContext} from '../../../../libs/shared/core/src/models/tracking/dataEventContexts';
import {OnboardingDataEventObject} from '../../../../libs/shared/core/src/models/tracking/objectNames/onboardingDataEventObject';
import {useDataEventTracking} from '../../../../libs/shared/core/src/services/tracking/dataEventTrackingContext';
import {DataEventTrackingProvider} from '../../../../libs/shared/core/src/services/tracking/dataEventTrackingProvider';
import {Button} from '../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {openInBrowser} from '../../../../srcCommon/browser/openInBrowser';
import {useAppSelector} from '../../../helpers/appReduxHelpers';
import {
  getHasIndividualTrainingAccess,
  getHasWebinarTrainingAccess,
} from '../../../store/data/company/companySelectors';
import {BottomBar} from './bottomBar';
import {BottomBarIndividualTrainingButton} from './trial/bottomBarIndividualTrainingButton';
import {BottomBarPurchaseButton} from './trial/bottomBarPurchaseButton';
import {BottomBarTrialInfo} from './trial/bottomBarTrialInfo';
import {BottomBarWebinarTrainingButton} from './trial/bottomBarWebinarTrainingButton';

/*
 * Component.
 */

const bottomBarDataContext: DataEventContext = Object.freeze({name: 'bottom_bar', payload: {}});

export const TrialExperienceBottomBar = () => {
  const hasIndividualTrainingAccess = useAppSelector(getHasIndividualTrainingAccess);
  const hasWebinarTrainingAccess = useAppSelector(getHasWebinarTrainingAccess);

  const renderTrainingButton = () => {
    if (hasIndividualTrainingAccess) {
      return <BottomBarIndividualTrainingButton />;
    }

    if (hasWebinarTrainingAccess) {
      return <BottomBarWebinarTrainingButton />;
    }

    return null;
  };

  const {trackDataEvent} = useDataEventTracking();

  const renderDownloadButton = () => {
    if (isElectron()) {
      return null;
    }

    return (
      <Button
        variant={ButtonVariantsEnum.SECONDARY}
        size={VisualSizesEnum.SMALL}
        onClick={() => {
          trackDataEvent(DataEventActionsEnum.OPEN_URL, OnboardingDataEventObject.DOWNLOAD_DESKTOP_APP);
          openInBrowser('https://front.com/download');
        }}
      >
        <Trans id="bottom-bar-download-desktop">Download Front for desktop</Trans>
      </Button>
    );
  };

  const renderText = () => <BottomBarTrialInfo />;
  const renderActionButtons = () => (
    <>
      <BottomBarPurchaseButton />
      {renderTrainingButton()}
      {renderDownloadButton()}
    </>
  );

  return (
    <DataEventTrackingProvider context={bottomBarDataContext}>
      <BottomBar renderText={renderText} renderActionButtons={renderActionButtons} />
    </DataEventTrackingProvider>
  );
};
